import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["disabled", "data-only-validate-for"]
const _hoisted_6 = { class: "input-group has-validation" }
const _hoisted_7 = ["disabled", "data-only-validate-for"]
const _hoisted_8 = ["title", "disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["title", "disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-double-right" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "invalid-feedback" }
const _hoisted_15 = ["disabled", "data-only-validate-for"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode("\n        ")
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadedOrPlaceholder = _resolveComponent("LoadedOrPlaceholder")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_iframe_event = _resolveDirective("iframe-event")!

  return (_openBlock(), _createElementBlock("tr", null, [
    (this.temporary)
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
          _createElementVNode("button", {
            disabled: this.disabled,
            type: "button",
            class: "btn btn-success",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('add', $event)))
          }, _hoisted_4, 8, _hoisted_2)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("td", null, [
            _createVNode(_component_LoadedOrPlaceholder, {
              value: _ctx.loadedReference,
              input: ""
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  disabled: this.disabled,
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loadedReference.realm) = $event)),
                  "data-only-validate-for": _ctx.onlyValidateFor
                }, null, 8, _hoisted_5), [
                  [_vModelText, _ctx.loadedReference.realm]
                ])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_LoadedOrPlaceholder, {
                value: _ctx.loadedReference,
                input: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    disabled: this.disabled,
                    type: "text",
                    class: "form-control",
                    required: "",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loadedReference.reference) = $event)),
                    "data-only-validate-for": _ctx.onlyValidateFor
                  }, null, 8, _hoisted_7), [
                    [_vModelText, _ctx.loadedReference.reference]
                  ])
                ]),
                _: 1
              }, 8, ["value"]),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary",
                "data-bs-toggle": "tooltip",
                title: _ctx.$t('review.upload.reference.attach'),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.attachFile && _ctx.attachFile(...args))),
                disabled: !(_ctx.loadedReference instanceof _ctx.TemporaryDocumentReference) || this.disabled,
                type: "button"
              }, _hoisted_10, 8, _hoisted_8),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary",
                "data-bs-toggle": "tooltip",
                title: _ctx.$t('review.upload.reference.referenceDocument'),
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.referenceDocumentVersion && _ctx.referenceDocumentVersion(...args))),
                disabled: !(_ctx.loadedReference instanceof _ctx.TemporaryDocumentReference) || this.disabled,
                type: "button"
              }, _hoisted_13, 8, _hoisted_11),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('review.upload.reference.missingReference')), 1)
            ])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_LoadedOrPlaceholder, {
              value: _ctx.loadedReference,
              input: ""
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  disabled: this.disabled,
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.loadedReference.gz) = $event)),
                  "data-only-validate-for": _ctx.onlyValidateFor
                }, null, 8, _hoisted_15), [
                  [_vModelText, _ctx.loadedReference.gz]
                ])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_LoadedOrPlaceholder, {
              value: _ctx.loadedReference,
              input: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DateInput, {
                  disabled: this.disabled,
                  utcSeconds: _ctx.loadedReference.created,
                  "onUpdate:utcSeconds": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loadedReference.created) = $event)),
                  "data-only-validate-for": _ctx.onlyValidateFor
                }, null, 8, ["disabled", "utcSeconds", "data-only-validate-for"])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("td", null, [
            (!_ctx.temporary)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: this.disabled,
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (this.$emit('delete')))
                }, _hoisted_18, 8, _hoisted_16))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: this.disabled,
                  type: "button",
                  class: "btn btn-success",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (this.$emit('add', $event)))
                }, _hoisted_21, 8, _hoisted_19))
          ])
        ], 64)),
    _createVNode(_component_Dialog, {
      lazy: "",
      title: _ctx.$t('review.upload.reference.selectDocumentTitle'),
      ref: "selectDocumentRef",
      extraClasses: "modal-fullscreen"
    }, {
      default: _withCtx(({ submit }) => [
        _withDirectives(_createElementVNode("iframe", {
          src: this.ctx.getDojoPageUrl('documentList', { 'mode': 'select' }),
          class: "w-100 h-100"
        }, _hoisted_24, 8, _hoisted_22), [
          [_directive_iframe_event, e => submit(e.detail), "select"]
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}